import { gql } from 'graphql-request'

export const GET_PEN_NAME_BY_USER_ID = gql`
  query GetPenNameByUserId(
    $id: Int!
    $searchText: String
    $page: Int
    $limitPerPage: Int
  ) {
    getPenNameByUserId(
      id: $id
      searchText: $searchText
      page: $page
      limitPerPage: $limitPerPage
    ) {
      data {
        id
        firstPenName
        facebookLink
        twitterLink
        totalFollower
        totalBook
        totalBookshelf
        totalRead
        isFollowed
        user {
          id
          writer {
            affiliation
          }
          displayName
          profilePageSlug
          avatarImgPath
        }
        books {
          id
          title
          writer
          tags {
            id
            name
          }
          category {
            id
            name
          }
          hasSalePromotions
          buyAllChaptersPromotion {
            startDate
            endDate
            discountType
            discountPercentage
          }
          readFreePromotion {
            startedAt
            endedAt
          }
          bookBadges {
            badgeCategoryId
            badgeImageUrl
          }
          bookChapterCampaignHeader {
            minSellingPrice
            totalChapter
            startedAt
            endedAt
          }
          coverImgPath
          coverResizeImgPath
          cover
          bookType
          likeCount
          commentCount
          viewCount
          isLiked
          isTranslated
          isEnded
          publishedChapterCount
          status
          writingType
          publishedAt
          isEpub
          isPdf
        }
      }
      total
      page
      totalPenName
    }
  }
`
